import React from 'react';
import logo from './logo.svg';
import { Counter } from './features/counter/Counter';
import './App.css';
import Header from'./componenets/Header'
import Home from './componenets/Home';

function App() {
  return (
    <div className="App">
      <Header/>
      <Home/>
      </div>
  );
      }
export default App;
